import React from 'react';
import { Outlet } from 'react-router-dom';

import { GlobalContainer } from '../ui/templates/global-container';
import { Header } from '../ui/templates/header';
import { Footer } from '../ui/templates/footer';
import { ContentWrapper } from '../ui/templates/content-wrapper';
import { BurgerMenu } from '../ui/atoms/burger-menu';

export const AppLayout: React.FC = () => {
  return (
    <GlobalContainer>
      <BurgerMenu />
      <Header />
      <ContentWrapper>
        <Outlet />
      </ContentWrapper>
      <Footer />
    </GlobalContainer>
  );
};
